import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'react-loaders';
import 'loaders.css/src/animations/ball-clip-rotate.scss';
import './styles.scss';


class LoadingIndicator extends React.Component {
  constructor (props) {
    super(props);
  };

  render() {

    const displayClass = this.props.show ? "" : "hide";

    return (
      <div className={displayClass}>
        <Loader type="ball-clip-rotate" />
      </div>
    )
  }
}


LoadingIndicator.propTypes = {
  show: PropTypes.bool
};


LoadingIndicator.defaultProps = {
  show: false
};



export { LoadingIndicator };
